export const CONTENTFUL_NAMES = {
  ContentfulArticleContentCard: 'ContentfulArticleContentCard',
  ContentfulArticleList: 'ContentfulArticleList',
  ContentfulArticleLongForm: 'ContentfulArticleLongForm',
  ContentfulArticlePodcast: 'ContentfulArticlePodcast',
  ContentfulCarouselImageContentCard: 'ContentfulCarouselImageContentCard',
  ContentfulCarouselSnippetsContentCard:
    'ContentfulCarouselSnippetsContentCard',
  ContentfulImageContentCard: 'ContentfulImageContentCard',
  ContentfulStaticContentCard: 'ContentfulStaticContentCard',
  ContentfulStory: 'ContentfulStory',
  ContentfulStoryContentCard: 'ContentfulStoryContentCard',
};
